import { api, LightningElement } from "lwc";

import { trackUserActivity } from "@devforce/th-components/modules/common/track/track";

export default class extends LightningElement {
  @api background: "white" | "dark" | "light" = "white";
  @api ctaHref: string | null = null;
  @api ctaLabel: string | null = null;
  @api ctaTarget: string | null = null;
  @api imgAlt: string | null = null;
  @api imgSrc: string | null = null;
  @api subtitle: string | null = null;
  @api title: string = "";

  private get endCapClassName() {
    return `end-cap end-cap--${this.background}`;
  }

  private handleCtaClick() {
    trackUserActivity(this, "cta_clicked", {
      ctaType: "primary",
      label: this.ctaLabel ?? "",
      pageLocation: "tm-end-cap-a",
    });
  }
}
